var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHearts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4793 10.7866C26.4793 11.3466 26.4393 11.8933 26.3727 12.4133C25.7593 12.1466 25.0927 12 24.386 12C22.7594 12 21.3194 12.7866 20.426 13.9866C19.5194 12.7866 18.0793 12 16.4527 12C13.7193 12 11.506 14.2266 11.506 16.9866C11.506 20.5599 13.3994 23.2933 15.506 25.1466C15.4394 25.1866 15.3727 25.2 15.306 25.2266C14.906 25.3733 14.2394 25.3733 13.8394 25.2266C10.386 24.04 2.66602 19.1333 2.66602 10.7866C2.66602 7.10662 5.626 4.1333 9.27934 4.1333C11.4527 4.1333 13.3727 5.17329 14.5727 6.78662C15.786 5.17329 17.706 4.1333 19.866 4.1333C23.5193 4.1333 26.4793 7.10662 26.4793 10.7866Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3325 16.9867C29.3325 23.2267 23.5592 26.9067 20.9725 27.7867C20.6659 27.8933 20.1725 27.8933 19.8658 27.7867C18.7592 27.4133 17.0659 26.52 15.5059 25.1466C13.3992 23.2933 11.5059 20.56 11.5059 16.9867C11.5059 14.2267 13.7192 12 16.4525 12C18.0792 12 19.5192 12.7867 20.4259 13.9867C21.3192 12.7867 22.7592 12 24.3859 12C25.0925 12 25.7592 12.1467 26.3725 12.4133C28.1192 13.1867 29.3325 14.9333 29.3325 16.9867Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHearts);
export default __webpack_public_path__ + "static/media/ico_hearts.d0032f0708140a78d21c613ecba81114.svg";
export { ForwardRef as ReactComponent };